export default "__VITE_ASSET__BQG669lp__"